import { component } from 'common/util/ComponentDecorator';
import './_brand-page.scss';

@component
export default class brandPage {
	static classname = 'brand-page';

	constructor($page) {
		this.$page = $page;

		this.decorate();
	}

	decorate() {
		this.$page.find('.brand-plugin-pages').attr('class', 'brand-page__links')
			.find('.brand-plugin-pages__item').attr('class', 'brand-page__link')
			.find('.brand-plugin-pages-item').each(function(){
			const $this = $(this);
			let isActive = !!$this.hasClass('brand-plugin-pages-item_current');
			$this.attr('class', 'btn btn--option large').toggleClass('active', isActive);
		});
		setTimeout(() => {
			this.$page.find('.brand-page__links-wrap').css({
				visibility: 'visible'
			});
		}, 0);
	}

}
